import { client } from '../client';

/**
 * DELETE /collector/users/:guardian_user_id/dependents/:dependent_id
 * Deactivate/remove a dependent in collector scope (collector auth).
 */
export const deleteCollectorDependent = async (
  guardianUserId: number,
  dependentId: number,
): Promise<void> => {
  await client.delete(`/collector/users/${guardianUserId}/dependents/${dependentId}`);
};
